<p-dialog showHeader="false"  [(visible)]="displayModal" [modal]="false" width="300" [baseZIndex]="10000" #dialDetail>
    <div class="animated fadeIn">
        <div class="row">
            <div class="col-md-12">
                <div class="table-responsive">
                    <table class="table table-sm table-striped">
                        <thead>
                            <tr>
                                <th scope="col" style="width: 10%"></th>
                                <th scope="col" style="width: 30%">
                                    Código
                                </th>
                                <th scope="col" style="width: 60%">
                                    Descripción
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of asyncInfoRequestCollection">
                                <td scope="row"></td>
                                <td>{{item.Caption}}</td>
                                <td>{{item.Description}}</td>
                            </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</p-dialog>